import { Button, message, Tabs } from "antd";

import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Link, useNavigate, useParams } from "react-router-dom";
import SearchBar from "../../components/SearchBar";

import ContentLayout from "../layout/ContentLayout";
import {
  enableMerchant,
  getMenus,
  getMerchant,
} from "../../actions/merchant_actions";
import Loading from "../../utils/Loading";
import MenuFormModal from "../merchant/MenuFormModal";
import MenuTable from "../merchant/MenuTable";
import MenuItems from "../merchant/MenuItems";
import SecretDisplay from "../merchant/SecretDisplay";
import MenuRewards from "../merchant/MenuRewards";
import MenuDiscounts from "../merchant/MenuDiscounts";

const cards = [
  {
    title: "total customers",
    data: 125,
    imgClass: "img-mov",
    imgSrc: "/assets/images/icons/insights/group.png",
  },
  {
    title: "total stamps",
    data: "40,689",
    imgClass: "img-pink",
    imgSrc: "/assets/images/icons/insights/path.png",
  },
  {
    title: "total vouchers",
    data: "40,689",
    imgClass: "img-orange",
    imgSrc: "/assets/images/icons/insights/reward.png",
  },
];

export default function Orders() {
  const navigate = useNavigate();
  const { accUrn, businessUrn } = useParams();
  const [enableLoading, setEnableLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const {
    refetch: refetchMerchant,
    isLoading: merchantLoading,
    data: merchantData,
  } = useQuery({
    queryKey: ["merchant", accUrn],
    queryFn: () => getMerchant({ account_urn: accUrn }),
    enabled: accUrn ? true : false,
  });

  const {
    refetch: refetchMenus,
    isLoading: menusLoading,
    data: menusData,
    error,
  } = useQuery({
    queryKey: ["menus", accUrn],
    queryFn: () => getMenus({ account_urn: accUrn }),
    enabled: accUrn ? true : false,
  });

  if (merchantLoading || menusLoading) return <Loading />;

  const handleEnableMerchant = () => {
    setEnableLoading(true);
    enableMerchant({ account_urn: accUrn, business_urn: businessUrn })
      .then(() => {
        refetchMerchant();
        window.location.reload();
      })
      .catch((err) => {
        message.error(err.response.data?.message || "Something went wrong!! ");
      });
    setEnableLoading(false);
  };

  const items = [
    {
      key: "1",
      label: "Menus",
      children: (
        <>
          <h2>Menu</h2>
          <div style={{ width: "100%" }} className="row">
            <Button
              type="primary"
              onClick={() => {
                setIsModalVisible(true);
              }}
            >
              + Create
            </Button>
            <MenuFormModal
              visible={isModalVisible}
              setVisible={setIsModalVisible}
              refetchMenus={() => {
                refetchMenus();
              }}
            />
            <Button
              onClick={() => {
                navigate("add");
              }}
            >
              Import
            </Button>
            <SearchBar />
          </div>
          <div style={{ width: "100%" }}>
            <MenuTable
              refetchMenus={() => {
                refetchMenus();
              }}
              data={menusData?.menus || []}
            />
          </div>
        </>
      ),
    },
    {
      key: "2",
      label: "Items",
      children: <MenuItems />,
    },
    {
      key: "3",
      label: "Rewards",
      children: (
        <MenuRewards
          data={merchantData?.data?.rewards}
          refetchMerchant={refetchMerchant}
        />
      ),
    },
    {
      key: "4",
      label: "Discounts",
      children: (
        <MenuDiscounts
          data={merchantData?.data?.discounts}
          refetchMerchant={refetchMerchant}
        />
      ),
    },
  ];

  return (
    <ContentLayout
      header={
        <>
          {!merchantData || error ? (
            <>
              <div className="screen-notification">
                <img src="/assets/images/bg/shop.png" alt="" />
                <h2 className="active">Start Your Online Merchant</h2>
                <h5>Create Your Merchant Now !!</h5>
                <Button
                  onClick={handleEnableMerchant}
                  className="btn primary"
                  loading={enableLoading}
                >
                  Enable Your Merchant Now
                </Button>
              </div>
            </>
          ) : (
            <>
              <h1>Merchant Dashboard</h1>
              <SecretDisplay merchantData={merchantData} />

              <div className="merchant-insights">
                {cards.map((card, index) => (
                  <Link to="orders">
                    <div className="insights_summary-card" key={index}>
                      <div className="insights_summary-card-header">
                        <div>
                          <h5>{card.title}</h5>
                          <h3>{card.data}</h3>
                        </div>
                        <div className={`img-container ${card.imgClass}`}>
                          <img src={card.imgSrc} alt={card.title} />
                        </div>
                      </div>
                      <div>
                        <h6>
                          <img
                            src="/assets/images/icons/insights/arrow.png"
                            alt="trend"
                          />
                          <span
                            className={
                              card.data.percentage_change >= 0
                                ? "active"
                                : "negative"
                            }
                          >
                            {card.data.percentage_change
                              ? ` ${card.data.percentage_change}%`
                              : "N/A"}
                          </span>
                          {card.data.percentage_change >= 0 ? "Up" : "Down"}{" "}
                          from previous period
                        </h6>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>

              <Tabs
                style={{ width: "100%" }}
                defaultActiveKey="1"
                items={items}
              />
            </>
          )}
        </>
      }
    ></ContentLayout>
  );
}
